const RWG_TOKEN_COOKIE = '_rwgToken';
const RWG_MERCHANT_ID_COOKIE = '_rwgMerchantId';
const COOKIE_MAX_AGE = 2592000;
const PRODUCTION_ENDPOINT = 'https://www.google.com/maps/conversion/collect';
const SANDBOX_ENDPOINT = 'https://www.google.com/maps/conversion/debug/collect';

function getCookieDomain() {
  if (typeof window !== 'undefined'
    && window.location.hostname.endsWith('ocard.co')) {
    return `domain=${window.location.hostname}; `;
  }
  return '';
}

function setCookie(name, value) {
  document.cookie = `${name}=${value}; max-age=${COOKIE_MAX_AGE}; path=/; ${getCookieDomain()}`;
}

function getCookie(name) {
  const cookies = document.cookie.split(';');
  const cookie = cookies.find((item) => item.trim().startsWith(`${name}=`));

  return cookie ? cookie.trim().slice(name.length + 1) : undefined;
}

function captureActionsCenterToken(route) {
  try {
    const token = route?.query?.rwg_token;

    if (typeof token !== 'string' || token === '') {
      return;
    }

    const decodedToken = decodeURIComponent(token);
    setCookie(RWG_TOKEN_COOKIE, decodedToken);
    setCookie(RWG_MERCHANT_ID_COOKIE, route?.params?.storeId || route?.params?.brandId || '');
  } catch (error) {
    // Ignore malformed tokens and cookie errors so navigation is unaffected.
  }
}

function getActionsCenterReferral() {
  try {
    const token = getCookie(RWG_TOKEN_COOKIE);

    if (!token) {
      return {};
    }

    return {
      rwgToken: token,
      merchantId: getCookie(RWG_MERCHANT_ID_COOKIE),
    };
  } catch (error) {
    return {};
  }
}

function getActionsCenterPartnerId() {
  return process.env.VUE_APP_ACTIONS_CENTER_PARTNER_ID;
}

function isSandbox() {
  if (process.env.NODE_ENV !== 'production') {
    return true;
  }

  return typeof window !== 'undefined'
    && new URLSearchParams(window.location.search).has('sandbox');
}

function sendActionsCenterConversion({ merchantId }) {
  try {
    const { rwgToken, merchantId: referredMerchantId } = getActionsCenterReferral();
    const partnerId = getActionsCenterPartnerId();

    if (!rwgToken || !partnerId || typeof fetch !== 'function') {
      return;
    }

    const endpoint = isSandbox() ? SANDBOX_ENDPOINT : PRODUCTION_ENDPOINT;
    const merchantChanged = referredMerchantId && referredMerchantId !== merchantId ? '1' : '2';

    fetch(endpoint, {
      method: 'POST',
      body: JSON.stringify({
        conversion_partner_id: partnerId,
        rwg_token: rwgToken,
        merchant_changed: merchantChanged,
      }),
      keepalive: true,
    }).catch(() => {});
  } catch (error) {
    // Conversion tracking must never block the checkout flow.
  }
}

export {
  captureActionsCenterToken,
  getActionsCenterReferral,
  getActionsCenterPartnerId,
  sendActionsCenterConversion,
};
